import { LOGIN } from "arv-extends/constants";

// Existing Constants Value Changes
LOGIN.LOGIN_MESSAGES.FB_TEXT = "Continue with Facebook";
LOGIN.LOGIN_MESSAGES.GOOGLE_TEXT = "Sign in with Google";
LOGIN.LOGIN_MESSAGES.FORGOT_PASS_TEXT = "forgot password?";
LOGIN.LOGIN_MESSAGES.LOGINPAGE_SUBTITLE = "to your account";
LOGIN.LOGIN_MESSAGES.REGISTER_TEXT = "CREATE AN ACCOUNT";
LOGIN.LOGIN_MESSAGES.LOGINPAGE_PH_PASSWORD = "Password";
LOGIN.LOGIN_MESSAGES.NEW_USER_TEXT = "Don't have an account?";
LOGIN.LOGIN_MESSAGES.REGISTERPAGE_PH_NAME = "Enter Your Name";
LOGIN.LOGIN_MESSAGES.REGISTERPAGE_PH_MOBILENO = "Enter your phone number";
LOGIN.LOGIN_MESSAGES.REGISTERPAGE_PH_EMAIL = "Enter your email";
LOGIN.LOGIN_MESSAGES.REGISTERPAGE_PH_PASSWORD = "Enter your password";
LOGIN.LOGIN_MESSAGES.SUCCESSFULL_SIGNUP_MESSAGE =
  "Welcome, you're one of us now. Thanks for signing up.";
export { LOGIN };
